(
    function (skyward, $)
    {
        //global private variables
        var formStates = { "Load": 1, "NewTypeCode": 2, "NewTypeCodeFromControlsType": 3, "Reload": 4 };
        var formState;
        var dataIn = '';
        var dataInAfterControlsType = '';
        var defaultTypeCode = null;
        var reloadDisplayAccount = null;
        var focusManuallySetForControlsTypeChange = false;
        var typeCodeSetFromInitailEntry = null;
        var hasControlsType;

        //global public variables
        skyward.accountLookupForm = skyward.accountLookupForm || {};
        skyward.accountLookupForm.isInitialized = false;

        skyward.accountLookupForm.initialize = function (reloadTypeCode)
        {
            if (reloadTypeCode != null && reloadTypeCode != "")
            {
                defaultTypeCode = reloadTypeCode;
            }
            else
            {
                defaultTypeCode = 'E';
            }

            formState = formStates.Load;

            skyward.accountLookupForm.isInitialized = true;
        };

        skyward.accountLookupForm.destroy = function ()
        {
            skyward.accountDimensionEEL.clearAllValues();
            skyward.accountlookupeel.makeEditable();
            dataIn = '';
            dataInAfterControlsType = '';
            formState = '';
            skyward.accountLookupForm.isInitialized = false;
        };

        skyward.accountLookupForm.setInitialData = function (value, typeCodePosition, isControlsType)
        {
            if (dataIn.length + 1 == typeCodePosition && isControlsType.toLowerCase() == 'false' && typeCodeSetFromInitailEntry == null)
            {
                switch (value)
                {

                    case "A":
                    case "1":
                        typeCodeSetFromInitailEntry = "A";
                        break;
                    case "L":
                    case "2":
                        typeCodeSetFromInitailEntry = "L";
                        break;
                    case "Q":
                    case "3":
                        typeCodeSetFromInitailEntry = "Q";
                        break;
                    case "R":
                    case "4":
                        typeCodeSetFromInitailEntry = "R";
                        break;
                    case "E":
                    case "5":
                        typeCodeSetFromInitailEntry = "E";
                        break;
                    default:
                        break;
                }
            }
            else
            {
                dataIn += value;
            }
        };

        var init = function (selector)
        {
            //private variables
            var typeCodeComboBox = $(selector + ' .cbTypeCode');
            hasControlsType = $('.ControlsType').length > 0;

            if (typeCodeComboBox.length > 0)
            {
                var typeCodeCharacterMapping = [
                    49, // 1
                    50, // 2
                    51, // 3
                    52, // 4
                    53, // 5
                    97, // Numpad 1
                    98, // Numpad 2
                    99, // Numpad 3
                    100,// Numpad 4
                    101,// Numpad 5
                    65, // A
                    76, // L
                    81, // Q
                    82, // R
                    69  // E
                ];

                typeCodeComboBox.val(defaultTypeCode);
                if (formState == formStates.Reload)
                {
                    skyward.accountDimensionEEL.accountReloadPrefillValues(reloadDisplayAccount);
                }

                //event wireups
                $(typeCodeComboBox).change(function ()
                {
                    if (formState != formStates.NewTypeCodeFromControlsType)
                    {
                        if (hasControlsType)
                        {
                            skyward.accountDimensionEEL.clearValues();
                        }
                        formState = formStates.NewTypeCode;
                        dimensionDescriptionReload();
                        reloadAccountLookupForm();
                    }
                });

                //private methods
                var reloadAccountLookupForm = function ()
                {
                    $('.accountLookupFormFieldSet').addClass('hidden');

                    var typeCode;
                    if (formState == formStates.Load && typeCodeSetFromInitailEntry != null)
                    {
                        typeCode = typeCodeSetFromInitailEntry;
                        typeCodeComboBox.val(typeCodeSetFromInitailEntry);
                        typeCodeSetFromInitailEntry = null;
                        typeCodeComboBox.change();
                    }
                    else
                    {
                        typeCode = typeCodeComboBox.val();
                    }

                    $(skyward.accountLookupForm.controlsByType[typeCode].controls).each(function (i)
                    {
                        var control = $('.' + skyward.accountLookupForm.controlsByType[typeCode].controls[i]);
                        control.removeClass('hidden');
                        control.appendTo(control.parent());
                    });

                    if (formState == formStates.Reload)
                    {
                        var lastDimensionEEL = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:last');
                        skyward.tabbing.focusAfter(lastDimensionEEL);
                        dimensionDescriptionReload();
                    }
                    else
                    {
                        var dimensionEELs = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode');
                        var firstDimensionEEL = $(dimensionEELs[0]);
                        if (formState == formStates.NewTypeCode && dataIn != '')
                        {
                            var usedCharacters = 0;
                            $(dimensionEELs).each(function (i)
                            {
                                var control = $(dimensionEELs[i]);
                                var eelMaxLength = parseInt(control.attr('maxLength'));
                                control.val(dataIn.substring(usedCharacters, (usedCharacters + eelMaxLength)));
                                if(dataIn.length < (eelMaxLength + usedCharacters))
                                {
                                    control.focus();
                                    return false;
                                }
                                else if (dataIn.length > (eelMaxLength + usedCharacters))
                                {
                                    usedCharacters = eelMaxLength + usedCharacters;

                                    if (control.hasClass('ControlsType'))
                                    {
                                        dataInAfterControlsType = dataIn.substring(usedCharacters);
                                    }

                                    skyward.accountDimensionEEL.setDescription(control, false);
                                    return true;
                                }
                                else
                                {
                                    skyward.accountDimensionEEL.setDescription(control, false);
                                    skyward.tabbing.focusAfter(control);
                                    return false;
                                }
                            });
                            dataIn = '';
                        }
                        else if (formState == formStates.Load)
                        {
                            skyward.tabbing.focusAfter(firstDimensionEEL);
                        }
                        else if (formState == formStates.NewTypeCode)
                        {
                            skyward.tabbing.focusAfter(typeCodeComboBox);
                        }
                        else if (formState == formStates.NewTypeCodeFromControlsType)
                        {
                            var encounteredControlsTypeEEL;
                            var dataCharactersUsed = 0;
                            dimensionEELs.each(function (index)
                            {
                                var currentControl = $(dimensionEELs[index]);
                                var currentEelMaxLength = parseInt(currentControl.attr('maxLength'));

                                if (currentControl.hasClass('ControlsType'))
                                {
                                    encounteredControlsTypeEEL = true;

                                    if (dataInAfterControlsType.length == 0)
                                    {
                                        return false;
                                    }

                                    return true;
                                }
                                if (encounteredControlsTypeEEL)
                                {
                                    currentControl.val(dataInAfterControlsType.substring(dataCharactersUsed, (dataCharactersUsed + currentEelMaxLength)));
                                    if(dataInAfterControlsType.length < (currentEelMaxLength + dataCharactersUsed))
                                    {
                                        currentControl.focus();
                                        focusManuallySetForControlsTypeChange = true;
                                        return false;
                                    }
                                    else if (dataInAfterControlsType.length > (currentEelMaxLength + dataCharactersUsed))
                                    {
                                        dataCharactersUsed = currentEelMaxLength + dataCharactersUsed;
                                        skyward.accountDimensionEEL.setDescription(currentControl, true);
                                        return true;
                                    }
                                    else
                                    {
                                        focusManuallySetForControlsTypeChange = true;
                                        skyward.accountDimensionEEL.setDescription(currentControl, true);
                                        skyward.accountLookupForm.checkForSingleAccount(currentControl);
                                        return false;
                                    }
                                }
                                else
                                {
                                    return true;
                                }
                            });
                        }
                    }
                };

                $(typeCodeComboBox).keydown(function (event)
                {
                    if (event.which >= 37 && event.which <= 40) //arrow keys
                    {
                        event.preventDefault();
                        return;
                    }

                    var storedValue = typeCodeComboBox.val();
                    var eventWhich = event.which;

                    var setTypeCodeComboBoxValue = function (newValue)
                    {
                        event.preventDefault();
                        if (newValue != storedValue)
                        {
                            formState = formStates.NewTypeCode;
                            typeCodeComboBox.val(newValue);
                            typeCodeComboBox.change();
                        }
                        else
                        {
                            //make sure to tab if the type code didn't change
                            skyward.tabbing.focusAfter(typeCodeComboBox);
                        }
                    };

                    switch (eventWhich)
                    {
                        //1 A
                        case 49:
                        case 97:
                        case 65:
                            setTypeCodeComboBoxValue('A');
                            break;
                        //2 L
                        case 50:
                        case 98:
                        case 76:
                            setTypeCodeComboBoxValue('L');
                            break;
                        //3 Q
                        case 51:
                        case 99:
                        case 81:
                            setTypeCodeComboBoxValue('Q');
                            break;
                        //4 R
                        case 52:
                        case 100:
                        case 82:
                            setTypeCodeComboBoxValue('R');
                            break;
                        //5 E
                        case 53:
                        case 101:
                        case 69:
                            setTypeCodeComboBoxValue('E');
                            break;
                        //enter
                        case 13:
                            skyward.tabbing.focusAfter(typeCodeComboBox);
                    }
                });

                var beforeDimensionEELKeyUp = function (event)
                {
                    //return when eel has its popup open, or when shift/tabbing, entering, or backspacing
                    if (skyward.accountDimensionEEL.popupModalLayerOpen || event.shiftKey || event.which == 16 || event.which == 9 || event.which == 8 || event.which == 13)
                    {
                        return;
                    }

                    var sender = $(event.currentTarget);
                    var senderMaxLength = sender.attr('maxlength');
                    var senderLength = sender.val().length;
                    var accountDimensionEELs = $('.accountLookupFormFieldSet:not(.hidden)').find('.accountDimensionEELCode');
                    var secondDimensionDOM = accountDimensionEELs.get(1);
                    var lastDimensionEELDOM = accountDimensionEELs.get(accountDimensionEELs.length - 1);

                    if (sender.get(0) == secondDimensionDOM && typeCodeCharacterMapping.indexOf(event.which) > -1)
                    {
                        return;
                    }

                    if (senderMaxLength == senderLength)
                    {
                        if (sender.hasClass('IsFund'))
                        {
                            return;
                        }

                        if (sender.get(0) == lastDimensionEELDOM)
                        {
                            checkForSingleAccount(accountDimensionEELs, sender);
                            sender.blur();
                        }
                        else
                        {
                            skyward.tabbing.focusAfter(sender);
                        }
                        sender.siblings('.accountDimensionEELCodeValue').val(sender.val()); //set hidden value
                    }
                };

                var beforeDimensionEELKeyDown = function (event)
                {
                    if (event.which == 8 && !skyward.accountDimensionEEL.popupModalLayerOpen) //backspace
                    {
                        var sender = $(event.currentTarget);
                        var senderDOM = sender.get(0);

                        var firstDimensionDOM = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:first').get(0);

                        var secondDimension = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:eq(1)');
                        var secondDimensionDOM = secondDimension.get(0);

                        var eelPopup = skyward.accountDimensionEEL.popupModalLayer;

                        if (sender.val() == '' && senderDOM != firstDimensionDOM && (eelPopup == null || eelPopup && !eelPopup.onScreen))
                        {
                            if (senderDOM == secondDimensionDOM && !secondDimension.hasClass('ControlsType'))
                            {
                                skyward.tabbing.focusBefore(typeCodeComboBox);
                            }
                            else
                            {
                                skyward.tabbing.focusBefore(sender);
                            }
                        }
                    }
                };

                var checkForSingleAccount = function (sender)
                {
                    skyward.tabbing.focusAfter(sender);
                };

                skyward.accountLookupForm.checkForSingleAccount = function (sender)
                {
                    var accountDimensionEELs = $('.accountLookupFormFieldSet:not(.hidden)').find('.accountDimensionEELCode');
                    var lastDimensionEELDOM = accountDimensionEELs.get(accountDimensionEELs.length - 1);
                    if (sender.get(0) == lastDimensionEELDOM)
                    {
                        checkForSingleAccount(sender);
                        sender.blur();
                    }
                };

                skyward.accountLookupForm.checkForSingleAccountFromSelect = function ()
                {
                    checkForSingleAccount();
                };

                var dimensionDescriptionReload = function ()
                {
                    $('.accountDimensionEELCode').each(function (i, o)
                    {
                        var dimensionCode = $(o);
                        skyward.accountDimensionEEL.setDescription(dimensionCode, true);
                    });
                };

                var controlsTypeChanged = function (sender, preventFocusChange)
                {
                    var code = $(sender);
                    var codeValue = code.val();

                    for (var typeCode in skyward.accountLookupForm.controlsByType)
                    {
                        var doBreak = false;
                        for (var i = 0; i < skyward.accountLookupForm.controlsByType[typeCode].codeLow.length; i++)
                        {
                            if (codeValue >= skyward.accountLookupForm.controlsByType[typeCode].codeLow[i] &&
                                codeValue <= skyward.accountLookupForm.controlsByType[typeCode].codeHigh[i]) 
                            {
                                if (typeCodeComboBox.val() != typeCode)
                                {
                                    formState = formStates.NewTypeCodeFromControlsType;

                                    typeCodeComboBox.val(typeCode);
                                    typeCodeComboBox.change(); //trigger change event for dependencies

                                    reloadAccountLookupForm();
                                }
                                if ((!focusManuallySetForControlsTypeChange && !preventFocusChange) || !preventFocusChange)
                                {
                                    skyward.tabbing.focusAfter(code);
                                }
                                doBreak = true;
                                break;
                            }
                        }

                        if (doBreak)
                        {
                            break;
                        }
                    }
                };

                var setInitialFocus = function ()
                {
                    if (skyward.global.mobileAccess)
                    {
                        return;
                    }
                    var accountDimensionEELs = $('.accountLookupFormFieldSet:not(.hidden)').find('.accountDimensionEELCode');
                    var firstDimensionEEL = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:first');
                    var lastDimensionEEL = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:last');
                    accountDimensionEELs.each(function ()
                    {
                        var currentEEL = $(this);

                        if (currentEEL.val().length < currentEEL.attr('maxLength'))
                        {
                            currentEEL.focus();
                            return false;
                        }
                        else if(currentEEL.val().length == currentEEL.attr('maxLength') && currentEEL.get(0) == lastDimensionEEL.get(0))
                        {
                            skyward.accountLookupForm.checkForSingleAccount(currentEEL);
                            return false;
                        }
                        else if (currentEEL.val().length == currentEEL.attr('maxLength') && currentEEL.get(0) == firstDimensionEEL.get(0))
                        {
                            typeCodeComboBox.focus();
                            return false;
                        }
                        else
                        {
                            return true;
                        }
                    });
                };

                //accountDimensionEEL callbacks
                skyward.accountDimensionEEL.setBeforeKeyUpCallback(beforeDimensionEELKeyUp);
                skyward.accountDimensionEEL.setBeforeKeyDownCallback(beforeDimensionEELKeyDown);
                skyward.accountDimensionEEL.setControlsTypeChangedCallback(controlsTypeChanged);

                //initialize form
                reloadAccountLookupForm();

                setInitialFocus();
            }
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);